// extracted by mini-css-extract-plugin
export default {"dialog":"SubscriptionRequiredDialog_dialog__ptHr8","formButton":"SubscriptionRequiredDialog_formButton__eYiKK"};